import { c as _c } from "react/compiler-runtime";
import { IconHourglassEmpty } from "@tabler/icons-react";
import { ms } from "ms";
import { Badge } from "@domainstack/ui/badge";
import { ResponsiveTooltip, ResponsiveTooltipContent, ResponsiveTooltipTrigger } from "@domainstack/ui/responsive-tooltip";
import { toDurationAttr } from "@domainstack/utils/date";
export function TtlBadge(t0) {
  const $ = _c(11);
  const {
    ttl
  } = t0;
  let t1;
  if ($[0] !== ttl) {
    t1 = toDurationAttr(ttl);
    $[0] = ttl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const duration = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconHourglassEmpty />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== duration || $[4] !== ttl) {
    t3 = <ResponsiveTooltipTrigger nativeButton={false} render={<Badge variant="outline" className="cursor-default py-1 text-[11px] leading-none text-muted-foreground">{t2}{duration ? <time dateTime={duration} suppressHydrationWarning={true}>{ms(ttl * 1000)}</time> : <span>-</span>}</Badge>} />;
    $[3] = duration;
    $[4] = ttl;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== ttl) {
    t4 = <ResponsiveTooltipContent><span className="font-mono text-xs">{ttl}</span></ResponsiveTooltipContent>;
    $[6] = ttl;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <ResponsiveTooltip>{t3}{t4}</ResponsiveTooltip>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}